module.exports = __webpack_public_path__ + "img/saint_Elme_loop.79dc08a2.jpg";